module.exports = __webpack_public_path__ + "img/heart-half-stroke.e9dc3eda.svg";